import React, { useEffect, useRef, useState } from 'react'
import {
    PiCaretDownFill,
    PiCaretUpFill,
    PiCheckCircleFill,
    PiWarningFill,
} from "react-icons/pi";
import { batchUploadFileAllNewMandates, debittingCountApi, faAppReport, getAllNewMandates, getAllNewMandatesTransactions, getAllWorkflowMandates, mailReportApi, mailworkFlowReportApi, searchAllNewMandates, singleDebitApi, smsworkFlowReportApi, validateAccountDownload, workFlowReportApi } from '../services';
import { notify } from '../components/actions/CommonActions';
import { Button, Form, Row, Col, InputGroup, Table } from "react-bootstrap";
import { FiRefreshCcw } from 'react-icons/fi';
import LoadingModal from '../components/modals/LoadingModal';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { GoDownload } from 'react-icons/go';

const AccountValidation = () => {
    const [loading, setLoading] = useState(false)
    const [selectedDetails, setSelectedDetails] = useState(null)
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [batchId, setBatchId] = useState(null)
    const dropdownRef = useRef(null);
    const [isUploadFile, setIsUploadFile] = useState(false);
    const [uploadedFile, setUploadedFile] = useState(null)
    const [showDownload, setShowDownload] = useState(false);
    const fileBlobRef = useRef(null); // or useState(null)

    const [stateTransact, setStateTransact] = React.useState({
        right: false,
    });
    const anchor = "right";
    const toggleDrawerTransact = (anchor, open, details) => (event) => {
        setSelectedDetails(details)
        // console.log('transact ', anchor, open);
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }

        setStateTransact({ ...stateTransact, [anchor]: open });
    }

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenDropdownId(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    const handleFileChangeNew = (e) => {
        const file = e.target.files[0];
        setUploadedFile(file)

    };

const handleUploadFileNew = async () => {
  setIsUploadFile(true);
    setShowDownload(false)
  const formData = new FormData();
  formData.append('file', uploadedFile);

  try {
    const blob = await validateAccountDownload(formData);
    fileBlobRef.current = blob; // store for later download
    setShowDownload(true)
    notify("success", "Successfully.", `Download ready.`);
  } catch (err) {
    console.log('Export error:', err);
    notify("danger", "OOPS", err?.response?.data?.message);
  } finally {
    setIsUploadFile(false);
  }
};


const handleCheckDownload = () => {
  const blob = fileBlobRef.current;
  if (!blob) {
    notify("warning", "No File", "No file is available for download yet.");
    return;
  }

  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = 'validate-account.xlsx';
  document.body.appendChild(link);
  link.click();

  // Cleanup
  window.URL.revokeObjectURL(link.href);
  link.remove();
};


    return (
        <>
            {loading ? (
                <div className="typewriter-container">
                    <div class="typewriter">
                        <div class="slide">
                            <i></i>
                        </div>
                        <div class="paper"></div>
                        <div class="keyboard"></div>
                    </div>
                    <code style={{ color: "#000" }}>Getting your app ready...</code>
                </div>
            ) : (
                <div>
                    <Row className="mb-3">
                        <Form.Group as={Col} controlId="formGridCity">
                            <Form.Label>Upload File</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type="file"
                                    placeholder="Upload excel file."
                                    name="excelFile"
                                    onChange={handleFileChangeNew}
                                />
                                <Button
                                    variant="outline-secondary"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleUploadFileNew();
                                    }}
                                    disabled={isUploadFile}
                                >
                                    {isUploadFile ? <FiRefreshCcw className="spin" /> : "Upload"}
                                </Button>
                            </InputGroup>
                        </Form.Group>
                    </Row>

                    {showDownload && <div style={{display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh", flexDirection: "column"}}>
                        <IoMdCheckmarkCircleOutline color="#007dcc" size={50} />
                        <p style={{fontSize: '20px'}}>Click download to Download file.</p>
                                                <button type="button" onClick={handleCheckDownload} style={{ border: "none", backgroundColor: "#007dcc", color: "white", padding: "4px 10px", borderRadius: "5px", marginLeft: "10px" }}><GoDownload color="white" />Download</button>
                    </div>
                    }
<LoadingModal show={isUploadFile} />
                </div>
            )}
        </>
    )
}

export default AccountValidation